module.exports = __webpack_public_path__ + "static/img/xm@2x.a6937ca2.png";